import { Logger } from '@montugroup/utilities';
import { initialize } from 'launchdarkly-react-client-sdk';
import { isMobile } from '../../utils/mobile';
const logger = new Logger('FeatureFlagsStore');
let ldClient = null;
export const defaultFeatureFlags = {
    enable_chatbot: false,
    zendesk_chat_handoff: false,
    zendesk_chat_handoff_button: false,
    persistent_chat_state: false,
    enable_surveys: false,
};
export const createFeatureFlagsSlice = (set, get) => ({
    flags: defaultFeatureFlags,
    loading: true,
    initialized: false,
    initializeLaunchDarkly: (clientId, flagOverrides) => {
        if (get().initialized) {
            return;
        }
        set({ initialized: true });
        ldClient = initializeLaunchDarklyClient(clientId);
        ldClient.on('ready', () => {
            if (!ldClient) {
                return;
            }
            const initialFlags = ldClient.allFlags();
            const userContext = initialFlags.anonymous_users
                ? { kind: 'user', anonymous: true, isMobile: isMobile() }
                : { kind: 'user', anonymous: true, key: 'shared-anonymous' };
            ldClient.identify(userContext).then(() => {
                if (!ldClient) {
                    return;
                }
                logger.enableDDogBrowserLogs = true;
                logger.info('Chatbot LD client identify success', { ...userContext });
                get().updateFlags(flagOverrides);
            });
        });
        ldClient.on('change', () => {
            get().updateFlags(flagOverrides);
        });
    },
    updateFlags: (flagOverrides) => {
        if (!ldClient) {
            return;
        }
        // We'll want to evaluate our flags when updating to trigger the datadog inspection
        const evaluatedFlags = {};
        const allFlagKeys = Object.keys(ldClient.allFlags());
        allFlagKeys.forEach((key) => {
            const detail = ldClient?.variationDetail(key, defaultFeatureFlags[key]);
            evaluatedFlags[key] = detail?.value;
        });
        set({
            flags: { ...defaultFeatureFlags, ...evaluatedFlags, ...flagOverrides },
            loading: false,
        });
    },
    closeLdClient: () => {
        if (ldClient) {
            ldClient.close();
            ldClient = null;
            set({ initialized: false, loading: true });
        }
    },
});
const initializeLaunchDarklyClient = (clientId) => {
    if (ldClient) {
        return ldClient;
    }
    const client = initialize(clientId, { kind: 'user', anonymous: true, key: 'shared-anonymous' }, {
        inspectors: [
            {
                type: 'flag-used',
                name: 'dd-inspector',
                method: (key, detail) => {
                    window.DD_RUM?.addFeatureFlagEvaluation(key, detail.value);
                },
            },
        ],
    });
    return client;
};
export const selectFeatureFlags = ({ flags }) => flags;
export const selectLaunchDarkly = ({ initializeLaunchDarkly, closeLdClient, loading }) => ({
    initializeLaunchDarkly,
    closeLdClient,
    loading,
});
//# sourceMappingURL=data:application/json;base64,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